module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-144x144-c26131ff24460d9d01443aa5b4fada77.png";